// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2s01M","inputWrap":"styles_inputWrap__d6NuL","input":"styles_input__3mTKb"};